<template>
  <div :class="{click: disableScreen}">
    <va-app :key="app_key" :desktop-sidebar-width="user !== null && ($route.matched[0].name != 'dashboard' ) ? 0 : 0"
      :desktop-minibar-width="user !== null && ($route.matched[0].name != 'dashboard' )  ? 0 : 0 "
      :desktop-topbar-height="user != null ? 100 : 0" :mobile-sidebar-width="0"
      :mobile-minibar-width="mobileMinibarWidth" :mobile-topbar-height="user != null ? 100 : 0"
      :sidebar-priority="sidebarPriority" :minibar-priority="minibarPriority" :reverse="reverse" :split="split"
      :rtl="rtl">

      <va-topbar v-if="user || $route.meta.isPublicView" theme="blue" class="md3" ref="topBar"
        style="min-height: 100px">

        <div slot="left" style="background:#fff0;
          align-items: center; min-height:100px;  justify-content: center;">

          <!-- mobile version -->
          <va-mobile v-if="user">

            <Drawer @close="toggle" align="left" :closeable="true">
              <div v-if="open && currentSectionIsOpen"
                style="display: flex; justify-content: flex-start; align-items: center">
                <va-icon size="2em" type="arrow-left" color="orange" @click.native="backToMainSection"></va-icon>
                <span style="    font-weight: bold;
                    text-transform: uppercase;
                    margin-left: 10px;
                    display: block;">{{ _(currentSection) }}</span>
              </div>

              <div style="margin-top: 40px" v-if="open">
                <va-button style="margin-bottom: 20px"
                  v-if="currentSectionIsOpen == true && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('surveys') || user.get('roles').includes('guest'))"
                  type='subtle-link' @click.native="mobileGoToDashboard(currentSection)">
                  {{ _("Dashboard") }}
                </va-button>

                <div v-if="currentSectionIsOpen" class="mobile_section_bar_group">
                  <h4>{{ _("Global Categories") }} </h4>
                  <router-link
                    v-for="globalCategory in getSectionGlobalCategories(currentSection.substring(0, currentSection.length - 1))"
                    class="mobile_btn" active-class="mobile_btn_active"
                    :to="'/' + globalCategory.get('type') + 's/global/' + globalCategory.get('slug')">{{
                          g_getLabel(globalCategory) }}</router-link>
                  <span v-if="user.get('roles').includes('admin')" class="mobile_section_bar_btn"
                    style="cursor: pointer" @click="showCategoryModal(null)">
                    <va-icon type="plus" color="gray"></va-icon> {{_('New')}}
                  </span>
                </div>

                <div v-if="currentSectionIsOpen && checkCondition" v-for="department in getTheDepartments"
                  class="mobile_section_bar_group">
                  <h4>{{ g_getLabel(department) }}</h4>
                  <router-link v-for="category in getSectionDepartmentCategories(currentSection, department)"
                    class="mobile_btn" active-class="mobile_btn_active"
                    :to="'/' + category.get('type') + 's/' + department.get('slug') + '/' + category.get('slug')">{{
                          g_getLabel(category) }}</router-link>
                  <span
                    v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager')) && (currentSection == 'surveys' || currentSection == 'articles' || currentSection == 'files' || currentSection == 'maps')"
                    class="mobile_section_bar_btn" style="cursor: pointer" @click="showCategoryModal(department)">
                    <va-icon type="plus" color="gray"></va-icon> {{_('New')}}
                  </span>
                </div>

                <div class="mobile_section_bar_group"
                  v-if="currentSectionIsOpen && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))">
                  <h4>{{ _("Reports") }} </h4>

                  <router-link
                    v-for="filter in getSectionFilters(currentSection.substring(0, currentSection.length - 1))"
                    class="section-bar-btn" :class="$route.fullPath==filter.get('url') ? 'mobile_btn_active' : ''"
                    :to="filter.get('url')">{{
                          g_getLabel(filter)}} </router-link>

                </div>
                <va-button
                  v-if="currentSectionIsOpen == false && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('surveys') || user.get('roles').includes('guest'))"
                  type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true, topbar_btn_highlight: currentSection == 'surveys'}"
                  @click.native="menuNavigation('surveys')">
                  {{ _("Surveys") }}
                </va-button>
                <va-button
                  v-if="currentSectionIsOpen == false &&  (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('articles') || user.get('roles').includes('guest'))"
                  type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: currentSection == 'articles'}"
                  @click.native="menuNavigation('articles')">
                  {{_("Articles")}}
                </va-button>

                <va-button
                  v-if="currentSectionIsOpen == false &&  (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('files') || user.get('roles').includes('guest'))"
                  type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: currentSection == 'files'}"
                  @click.native="menuNavigation('files')">

                  {{_("Files")}}
                </va-button>

                <va-button
                  v-if="currentSectionIsOpen == false &&   (user && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('maps')) || user.get('roles').includes('guest'))"
                  style=" margin-right:30px !important;" type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: currentSection == 'maps'}"
                  @click.native="menuNavigation('maps')">
                  {{_("Maps")}}

                </va-button>
                <hr>

                <va-button
                  v-if=" (user && (user.get('roles').includes('admin') || user.get('roles').includes('manager')) && ($route.matched[0] && (currentSection == 'surveys' || currentSection == 'articles' || currentSection == 'files' || currentSection == 'maps')))"
                  style="margin-left: 10px; color: #fffa !important;" type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: $route.path.includes('/' + currentSection + '/reports')}"
                  @click.native="menuNavigation(currentSection + '/reports/list')">
                  {{_("Reports")}}
                </va-button>

                <va-button
                  v-if="(user && (user.get('roles').includes('admin') || user.get('roles').includes('manager')) && ($route.matched[0] && $route.params.scope && $route.params.category && (currentSection == 'articles' || currentSection == 'files' || currentSection == 'maps')))"
                  style="color: #fffa !important;" type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: $route.path.includes('/' + currentSection + '/' + $route.params.scope + '/' + $route.params.category + '/meta-forms')}"
                  @click.native="menuNavigation(currentSection + '/' + $route.params.scope + '/' + $route.params.category + '/meta-forms')">
                  {{_("Meta Forms")}}
                </va-button>

                <va-button
                  v-if="(user && (user.get('roles').includes('admin') || user.get('roles').includes('manager')))"
                  style="color: #fffa !important;" type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: currentSection.includes('users')}"
                  @click.native="menuNavigation('users')">
                  {{_("Users")}}
                </va-button>

                <va-button
                  v-if="user && !user.get('roles').includes('guest') && (user.get('roles').includes('admin') || user.get('departments'))"
                  style="color: #fffa !important;" type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: currentSection.includes('departments')}"
                  @click.native="menuNavigation('departments')">
                  {{_("Departments")}}
                </va-button>

                <va-button v-if="user.get('roles').includes('admin')" style="color: #fffa !important;"
                  type='subtle-link'
                  :class="{topbar_btn: true, topbar_btn_mobile: true,  topbar_btn_highlight: currentSection.includes('words')}"
                  @click.native="menuNavigation('words')">
                  {{_("Words")}}
                </va-button>
              </div>
            </Drawer>

          </va-mobile>
          <!-- mobile end -->

          <div :class="{brand_icon:  getScreenWidth <= 425, brand_icon_desktop: getScreenWidth > 425}">
            <va-icon @click.native="toggle" type="align-left" size="1.25em" color="#fff" bg-color="#2196F3"
              padding="14px 14px 12px">
            </va-icon>

            <va-button v-if="$route.meta.isPublicView" type="subtle-link">
              <span style="font-weight:200;margin:0 40px 0 10px; color: #fffa;">
                NEIS | NEPA
              </span>
            </va-button>

            <va-button v-else type="subtle-link" @click.native="menuNavigation('')">
              <span style="font-weight:200;margin:0 40px 0 10px; color: #fffa;">
                NEIS | NEPA
              </span>
            </va-button>

          </div>
          <va-desktop>

            <div v-if="!$route.meta.isPublicView" style="display:inline-block; margin-top:14px;">
              <va-button
                v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('surveys') || user.get('roles').includes('guest')"
                type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name == 'surveys'}"
                @click.native="menuNavigation('surveys')">
                {{ _("Surveys") }}
              </va-button>

              <va-button
                v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('articles') || user.get('roles').includes('guest')"
                type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name == 'articles'}"
                @click.native="menuNavigation('articles')">
                {{_("Articles")}}
              </va-button>

              <va-button
                v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('files') || user.get('roles').includes('guest')"
                type='subtle-link' :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name == 'files'}"
                @click.native="menuNavigation('files')">

                {{_("Files")}}
              </va-button>

              <va-button
                v-if="user && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('maps')) || user.get('roles').includes('guest')"
                style=" margin-right:30px !important;" type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name == 'maps'}"
                @click.native="menuNavigation('maps')">
                {{_("Maps")}}

              </va-button>

              <span class="section" v-if="!user.get('roles').includes('guest')">{{ _(currentSection) }}</span>

              <va-button
                v-if="user && (user.get('roles').includes('admin') || user.get('roles').includes('manager')) && ($route.matched[0] && ($route.matched[0].name == 'surveys' || $route.matched[0].name == 'articles' || $route.matched[0].name == 'files' || $route.matched[0].name == 'maps'))"
                style="font-size:.9em; color: #fffa !important;" type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.path.includes('/' + currentSection + '/reports')}"
                @click.native="menuNavigation(currentSection + '/reports/list')">
                {{_("Reports")}}
              </va-button>

              <va-button
                v-if="user && (user.get('roles').includes('admin') || user.get('roles').includes('manager')) && ($route.matched[0] && $route.params.scope && $route.params.category && ($route.matched[0].name == 'articles' || $route.matched[0].name == 'files' || $route.matched[0].name == 'maps'))"
                style="font-size:.9em; color: #fffa !important;" type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.path.includes('/' + currentSection + '/' + $route.params.scope + '/' + $route.params.category + '/meta-forms')}"
                @click.native="menuNavigation(currentSection + '/' + $route.params.scope + '/' + $route.params.category + '/meta-forms')">
                {{_("Meta Forms")}}
              </va-button>

              <span class="section" v-if="!user.get('roles').includes('guest')">{{ _('Settings') }}</span>

              <va-button v-if="user && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                style="font-size:.9em; color: #fffa !important;" type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name.includes('users')}"
                @click.native="menuNavigation('users')">
                {{_("Users")}}
              </va-button>

              <va-button
                v-if="user && !user.get('roles').includes('guest') && (user.get('roles').includes('admin') || user.get('departments'))"
                style="font-size:.9em; color: #fffa !important;" type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name.includes('departments')}"
                @click.native="menuNavigation('departments')">
                {{_("Departments")}}
              </va-button>

              <va-button v-if="user.get('roles').includes('admin')" style="font-size:.9em; color: #fffa !important;"
                type='subtle-link'
                :class="{topbar_btn: true, topbar_btn_highlight: $route.matched[0].name.includes('words')}"
                @click.native="menuNavigation('words')">
                {{_("Words")}}
              </va-button>

            </div>
          </va-desktop>

        </div>
        <div slot="right" v-if="user || $route.meta.isPublicView" style="margin-top:14px;">
          <va-button v-if="showChatButton && !$route.meta.isPublicView" type='dark'
            :class="{chat_btn:true, topbar_btn: true, chat_btn_shown: showChat}" @click.native="toggleChat">
            {{getScreenWidth <= 425 ? showChat ? 'C' : 'O' : showChat ? 'CLOSE CHAT' : _("OPEN CHAT")}}
          </va-button>

          <va-dropdown class="languageChanger" :click-close="false" ref="systemLangDropDown"
            v-if="!$route.meta.isPublicView">
            <div style="padding:12px; padding-right:18px; margin-right:10px;" slot="trigger">
              <img v-if="getSystemLanguage == 'english'" src="@/assets/america.png" alt="" style="width: 20px">

              <img v-else src="@/assets/afghanistan.png" alt="" style="width: 20px">
            </div>
            <li><a @click="changeSystemLanguageTo('english')">English</a></li>
            <li><a @click="changeSystemLanguageTo('pashto')">پښتو</a></li>
            <li><a @click="changeSystemLanguageTo('dari')">دری</a></li>
          </va-dropdown>

          <va-dropdown v-if="user && !$route.meta.isPublicView" :click-close="false" effect="fadeDown"
            ref="notificationPanel" class="notifs">
            <div slot="trigger">
              <div class="profileAvatar">
                <span class="profile-menu-name">{{ myUser.get('name') }}</span>
                <va-icon type="chevron-down" />

                <img width="32px" height="32px" style="border-radius: 100px;" v-if="myUser.get('profilePic')"
                  :src="myUser.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')"
                  alt="profile picture">
                <img width="32px" height="32px" style="border-radius: 100px;" v-else src="@/assets/emptyProfile.jpg"
                  alt="profile picture">

                <va-badge v-if="allUnseenNotifications != 0" type="danger">{{
                  allUnseenNotifications }}</va-badge>
              </div>
            </div>
            <div class="notification_panel">
              <va-row class="notification_panel_row">
                <va-column :xs="12" style="overflow: scroll; height: 400px;" v-if="allNotifications != 0">
                  <div v-for="(notification, index) in notifications" @click="navigate(notification)"
                    v-if="notification && notification.get('createdBy')!=null">
                    <div
                      :class="{unseen_notification: !notification.get('seen'), seen_notification: notification.get('seen')}">
                      <img v-if="notification.get('createdBy').get('profilePic') != ''" width="32px" height="32px"
                        style="border-radius: 100px;"
                        :src="notification.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')"
                        alt="profile picture">
                      <img v-else width="32px" height="32px" style="border-radius: 100px;"
                        src="@/assets/emptyProfile.jpg" alt="profile picture">

                      <span class="notification_text">
                        <span class="notification_sender">{{
                          notification.get('createdBy').get('name') }}</span>

                        <span>
                          {{ g_getActivityAction(notification) }}
                          <br><span style="color: gray; font-size: 12px">{{
                            getTime(notification.get('createdAt')) }}</span>
                        </span>
                      </span>

                    </div>
                  </div>
                  <div v-if="allNotifications > notifications.length && allNotifications > 10"
                    style="display: flex; justify-content: center; margin-top: 20px">
                    <va-button type="subtle" @click.native="fetchNotifications(++pageNumber)">
                      <va-icon style="padding: 0 !important; padding-right: 10px !important" type="sync-alt"></va-icon>
                      {{ _("Load more notifications") }}
                    </va-button>
                  </div>
                </va-column>
                <va-column v-else :xs="12"
                  style="display: flex; justify-content: center; align-items: center; ;height: 400px; color: black">
                  <div style="display: flex; flex-direction: column">
                    <span>{{ _("No notifications") }} </span>
                    <va-button :loading="notificationLoader" style="margin-top:10px" type="default"
                      @click.native="fetchNotificationsAndCount">
                      {{ _('Reload') }}</va-button>
                  </div>
                </va-column>

              </va-row>

              <va-row class="notification_panel_btns_row">
                <va-column :xs="12" style="display: flex;
                                      justify-content: space-around;">
                  <va-button @click.native="goto('/users/' + user.id)" style="width: 100%">{{
                    _("Profile") }}</va-button>
                  <va-button @click.native="logout" style="width: 100%">{{ _("Logout") }}</va-button>
                </va-column>
              </va-row>
            </div>
          </va-dropdown>

        </div>
      </va-topbar>

      <va-page size="md" ref="pageContainer"
        :class="{md2: true,show_chat:showChat, sidebar_margin: !$route.meta.hideSidebar && user && !user.get('roles').includes('guest'), login_background: $route.matched[0].name=='login', dash_background: $route.matched[0].name=='dashboard'}">
        <va-desktop>

          <div class="section-bar-sidebar"
            v-if="!$route.meta.hideSidebar && user && !user.get('roles').includes('guest')">
            <va-affix>

              <!-- global categories -->
              <div class="section-bar-group">
                <h4>{{ _("Global Categories") }} </h4>
                <router-link
                  v-for="globalCategory in getSectionGlobalCategories($route.matched[0].name.substring(0, $route.matched[0].name.length - 1))"
                  class="section-bar-btn" active-class="section-bar-btn-active"
                  :to="'/' + globalCategory.get('type') + 's/global/' + globalCategory.get('slug')">{{
                  g_getLabel(globalCategory) }}</router-link>
                <span v-if="user.get('roles').includes('admin')" class="section-bar-btn" style="cursor: pointer"
                  @click="showCategoryModal(null)">
                  <va-icon type="plus" color="gray"></va-icon> {{_('New')}}
                </span>
              </div>

              <!-- departments and their categories -->
              <div v-if="checkCondition" v-for="department in getTheDepartments" class="section-bar-group">
                <h4>{{ g_getLabel(department) }}</h4>
                <router-link v-for="category in getSectionDepartmentCategories($route.matched[0].name, department)"
                  class="section-bar-btn" active-class="section-bar-btn-active"
                  :to="'/' + category.get('type') + 's/' + department.get('slug') + '/' + category.get('slug')">{{
                  g_getLabel(category) }}</router-link>
                <span
                  v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager')) && ($route.matched[0].name == 'surveys' || $route.matched[0].name == 'articles' || $route.matched[0].name == 'files' || $route.matched[0].name == 'maps')"
                  class="section-bar-btn" style="cursor: pointer" @click="showCategoryModal(department)">
                  <va-icon type="plus" color="gray"></va-icon> {{_('New')}}
                </span>
              </div>

              <!-- reports -->
              <!-- <div class="section-bar-group"
                v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager')">
                <h4>{{ _("Reports") }} </h4>

                <router-link
                  v-for="filter in getSectionFilters($route.matched[0].name.substring(0, $route.matched[0].name.length - 1))"
                  class="section-bar-btn" :class="$route.fullPath==filter.get('url') ? 'section-bar-btn-active' : ''"
                  :to="filter.get('url')">{{
                  g_getLabel(filter)}} </router-link>

              </div> -->
            </va-affix>
          </div>
        </va-desktop>

        <va-loading class="screen_loading" v-show="loading" size="md" color="gray" :center="true" />
        <router-view :class="{dimmed: loading}" />
        <notifications group="foo" style="margin-top: 120px" />

        <iframe allow="microphone; camera" @load="chatLoaded" v-show="showChat" ref="chatFrame"
          src="https://nepachat.speensoft.net" name="chatFrame"
          :class="{large_screen_chat: true, small_screen_chat: getScreenWidth <= 425}"></iframe>
      </va-page>

      <category v-if="makeCategoryModalVisible" :class="{click: disableScreen}" v-on:hide-modal="hideCategoryModal"
        v-on:disable-screen="setDisableScreenValue" :title="_(getCategoryModalTitle)"
        :department="categoryDepartment" />

    </va-app>
  </div>
</template>

<script>
  import Parse from "@/main.js"
  import {
    store
  } from "./store";
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import moment from 'moment';
  import axios from 'axios';
  import Activities from "./views/Activities.vue"
  import { Slide } from 'vue-burger-menu'
  import Slider from '@jeremyhamm/vue-slider'
  import Drawer from "vue-simple-drawer"
  import Category from "./views/Category.vue"

  export default {
    components: {
      Activities,
      Slide,
      Slider,
      Drawer,
      Category
    },
    data() {
      return {
        app_key: '',
        showChat: false,
        chatLoggedIn: false,
        showChatButton: false,
        parentRoute: '',
        desktopSidebarWidth: 240,
        desktopMinibarWidth: 64,
        desktopTopbarHeight: 64,
        mobileSidebarWidth: 0,
        mobileMinibarWidth: 0,
        mobileTopbarHeight: 0,
        sidebarPriority: false,
        minibarPriority: false,
        rtl: false,
        reverse: false,
        split: false,
        sidebarTheme: 'default',
        sidebarLoading: false,
        categories: [],
        reports: [{
          name: 'AnimQueue',
          route: '/documentation/animqueue'
        },],
        userManagement: [{
          name: 'Users',
          route: '/users'
        },
        {
          name: 'Departments',
          route: '/departments'
        },
          // { name: 'Create User', route: '/user/new' },
        ],
        metaFormManagement: [],
        groupManagement: [{
          name: 'Groups',
          route: '/groups'
        },
          // { name: 'Create Group', route: '/group/new' },
        ],
        filters: [],
        profilePicUrl: '',

        newCategory: '',
        newCategoryPashto: '',
        newCategoryDari: '',
        unseenNotificationsCount: 0,
        notifications: [],
        allNotifications: 0,
        allUnseenNotifications: 0,
        notificationLoader: false,
        pageNumber: 1,
        profileName: '',
        selectedGroup: null,
        systemLanguage: 'english',
        currentMenu: '',
        currentDep: null,
        categoryScope: null,
        myUser: { get: () => '' },
        section: '',
        currentSectionIsOpen: false,
        open: false,
        mobileParentSection: '',

        //category
        makeCategoryModalVisible: false,
        categoryDepartment: null,
        disableScreen: false,
      };
    },
    watch: {
      async user(val) {
        if (val) {
        }
        if (val && this.$route.matched[0].name == 'login')
          this.$router.replace("/");
        this.app_key = Date.now();
      },

      async '$route'(v) {
        if (this.open == true) {
          if (v.fullPath != '/surveys' && v.fullPath != '/articles' && v.fullPath != '/files' && v.fullPath != '/maps' && v.fullPath != '/' + this.currentSection + '/reports/list' && v.fullPath != '/' + this.currentSection + '/meta-forms' && v.fullPath != '/users' && v.fullPath != '/departments' && v.fullPath != '/words') {
            this.toggle()
          }
        }
      }
    },
    computed: {

      ...mapGetters(['getUserDepartmentsFromState', 'getCurrentDepartmentCategories', 'getAllFilters', 'getSectionFilters', 'getSectionGlobalCategories', 'getSectionDepartmentCategories', 'getAllDepartments', 'getCurrentDepartment',
        'loading', 'getSystemLanguage']),

      checkCondition() {
        if (this.user.get('roles').includes('admin') || this.user.get('roles').includes('manager') || this.user.get('roles').includes('surveys') || this.user.get('roles').includes('articles') || this.user.get('roles').includes('files') || this.user.get('roles').includes('maps')) {
          return true
        }
        return false
      },

      getTheDepartments() {
        if (this.user.get('roles').includes('admin')) {
          return this.getAllDepartments
        } else if (this.user.get('roles').includes('manager') || this.user.get('roles').includes('surveys') || this.user.get('roles').includes('articles') || this.user.get('roles').includes('files') || this.user.get('roles').includes('maps')) {
          return this.getUserDepartmentsFromState
        }
      },

      getScreenWidth() {
        if (window != null && window.screen != null && window.screen.width != null) {
          return window.screen.width;
        }
        return 426
      },

      currentSection() {
        let parent = this.$route.matched[0].name
        if (this.open) {
          return this.mobileParentSection;
        }
        if (parent == 'surveys' || parent == 'articles' || parent == 'files' || parent == 'maps') return parent
      },

      getCategoryModalTitle() {
        if (this.$route.matched[0].name == 'surveys') return 'New survey category'
        else if (this.$route.matched[0].name == 'articles') return 'New article category'
        else if (this.$route.matched[0].name == 'files') return 'New file category'
        else if (this.$route.matched[0].name == 'maps') return 'New map category'
        else return 'N/A'
      },

      getCategorySuccessText() {
        if (this.parentRoute == 'surveys') return this._('Survey category was generated')
        else if (this.parentRoute == 'articles') return this._('Article category was generated')
        else if (this.parentRoute == 'articles') return this._('File category was generated')
        else return this._('Map category was generated')
      },


      user() {
        return store.getters.user;
      },

    },
    methods: {
      ...mapActions(['fetchGlobalCategories', 'fetchDepartments', 'setSystemLanguage', 'fetchDepartmentCategories', 'logout']),

      // start cateogry

      setDisableScreenValue(val) {
        this.disableScreen = val
      },


      hideCategoryModal() {
        this.makeCategoryModalVisible = false
      },

      showCategoryModal(department) {
        this.makeCategoryModalVisible = true
        this.categoryDepartment = department
      },
      // end category

      async navigate(activity) {
        this.$refs.notificationPanel.close()
        if (!activity.get('seen')) {
          activity.set('seen', true)
          activity.save()
        }
        var id
        if (activity.get('class') == 'Filter') {
          id = activity.get('url').split('=')[1]
        } else {
          id = activity.get('url').split('/')[activity.get('url').split('/').length - 1]
        }

        // !this.$route.params.id
        if (activity && activity.get('action') != 'delete' && activity.get('action') != 'deleteFilters' && activity.get('action') != 'deleteSubmissions') {

          if (activity.get('class') == 'Category') {
            // for category
            let q = new Parse.Query('Cateogry')
            q.equalTo('slug', id)
            let result = await q.first()
            if (!result) {
              this.$router.push(activity.get('url'))
            } else {
              this.$notify({
                group: 'foo',
                text: this._('There is an error navigating to this link, the object might not exist'),
                duration: 4000,
                position: 'top left',
                type: 'error'
              });
            }

          } else {
            if (id != 'list') {
              this.g_fetchObject(id, activity.get('class')).then(async res => {
                if (activity.get('class') == 'Form')
                  if (res.get('is_enabled'))
                    if (this.user.get('roles').includes('guest')) {
                      if (res.get('shared_with') != null) {
                        for (let index = 0; index < res.get('shared_with').length; index++) {
                          if (res.get('shared_with')[index].id == this.user.id) {
                            this.$router.push(activity.get('url'))
                            break;
                          }
                        }
                      }
                    } else {
                      this.$router.push(activity.get('url'))
                    }

                  else {
                    this.$notify({
                      group: 'foo',
                      text: this._('There is an error navigating to this link, the object might not exist'),
                      duration: 4000,
                      position: 'top left',
                      type: 'error'
                    });
                  }
                else if (activity.get('class') == 'Article' || activity.get('class') == 'File' || activity.get('class') == 'Map') {
                  if (res.get('status') == 'approved') {

                    if (this.user.get('roles').includes('guest')) {
                      if (res.get('shared_with') != null) {
                        for (let index = 0; index < res.get('shared_with').length; index++) {
                          if (res.get('shared_with')[index].id == this.user.id) {
                            this.$router.push(activity.get('url'))
                            break;
                          }
                        }
                      }
                    } else {
                      this.$router.push(activity.get('url'))
                    }
                  }
                  else if (res.get('status') == 'rejected' || res.get('status') == 'pending') {
                    if (this.user.get('roles').includes('admin') || this.user.get('roles').includes('manager')) {
                      this.$router.push(activity.get('url'))
                    } else {
                      if (this.user.get('roles').includes('guest')) {
                        if (res.get('shared_with') != null) {
                          for (let index = 0; index < res.get('shared_with').length; index++) {
                            if (res.get('shared_with')[index].id == this.user.id) {
                              this.$router.push(activity.get('url'))
                              break;
                            }
                          }
                        }
                      } else {
                        if (res.get('createdBy').id == this.user.id) {
                          this.$router.push(activity.get('url'))
                          await this.fetchUnseenNotificationsCount()
                          return;
                        }
                        for (const key in res.get('approvers')) {

                          if (res.get('approvers')[key].id == this.user.id) {
                            this.$router.push(activity.get('url'))
                            await this.fetchUnseenNotificationsCount()
                            return;
                          }
                        }
                        this.$notify({
                          group: 'foo',
                          text: this._('You do not have the permission to view this ' + activity.get('class').toLowerCase()),
                          duration: 4000,
                          position: 'top left',
                          type: 'error'
                        });
                      }
                    }
                  }
                }
                else
                  this.$router.push(activity.get('url'))

              }).catch(e => {
                this.$notify({
                  group: 'foo',
                  text: this._('There is an error navigating to this link, the object might not exist'),
                  duration: 4000,
                  position: 'top left',
                  type: 'error'
                });
              })
            } else {
              let className = 'Data_' + activity.get('url').split('/')[activity.get('url').split('/').length - 2]
              let q = new Parse.Query('Form')
              q.equalTo('is_enabled', true)
              q.equalTo('class_name', className)
              let result = await q.first()
              if (result)
                this.$router.push(activity.get('url'))
              else {
                this.$notify({
                  group: 'foo',
                  text: this._('There is an error navigating to this link, the object might not exist'),
                  duration: 4000,
                  position: 'top left',
                  type: 'error'
                });
              }
            }
          }
        }
        await this.fetchUnseenNotificationsCount()
      },

      async fetchUnseenNotificationsCount() {
        let q = new Parse.Query('Activity')
        q.equalTo('to', this.myUser)
        q.equalTo('seen', false)
        this.allUnseenNotifications = await q.count()
      },

      async fetchNotificationsAndCount() {
        this.notificationLoader = true
        await this.fetchNotifications(1)
        await this.fetchNotificationsCount()
        this.notificationLoader = false
      },


      async fetchNotifications(pageNumber) {
        let q = new Parse.Query('Activity')
        q.equalTo('to', this.myUser)
        q.include('createdBy')
        q.descending("createdAt")
        q.skip((pageNumber - 1) * 10)
        q.limit(10)
        let result = await q.find()

        let subscription = await q.subscribe();
        subscription.on('create', async (activity) => {
          this.notifications.unshift(activity)
          await this.fetchNotificationsCount()
          await this.fetchUnseenNotificationsCount()
        });
        this.notifications.push(...result)

      },

      async fetchNotificationsCount() {
        let q = new Parse.Query('Activity')
        q.equalTo('to', this.myUser)
        this.allNotifications = await q.count()
      },

      backToMainSection() {
        this.currentSectionIsOpen = !this.currentSectionIsOpen
      },

      toggle() {
        this.open = !this.open
      },

      mobileGoToDashboard(route) {
        this.$router.push('/' + route)
        this.toggle()
      },


      async menuNavigation(route) {
        if (route == this.currentSection + '/reports/list' || route == this.currentSection + '/' + this.$route.params.scope + '/' + this.$route.params.category + '/meta-forms' || route == 'users' || route == 'departments' || route == 'words') {
          if (this.getScreenWidth <= 425) this.toggle()
          this.$router.push('/' + route)
        } else {
          this.currentSectionIsOpen = true;
        }

        if (route.includes('departments/')) {
          this.$router.push('/' + route)
        }

        if (route == 'surveys' || route == 'articles' || route == 'files' || route == 'maps') {
          this.mobileParentSection = route;
          if (this.open == true) {
            this.section = this.currentSection.substring(0, this.currentSection.length - 1)
          } else {
            if (this.user.get('roles').includes('admin')) {
              this.fetchDepartments()
            }
            else {
              this.fetchDepartmentCategories()
            }
            this.$router.push('/' + route)
          }
        }
        if (route == '') {
          this.$router.push('/' + route)
        }
      },

      changeSystemLanguageTo(lang) {
        this.setSystemLanguage(lang)
        if (this.$refs.systemLangDropDown) {
          this.$refs.systemLangDropDown.close()
        }


      },

      getTime(time) {
        return moment(time).fromNow()
      },

      // async navigate(notification) {
      //   if (!notification.get('seen') && notification.get('to')) {
      //     notification.set('seen', true)
      //     await notification.save()
      //   }
      //   if (notification.get('type') != 'user' && !this.$route.params.id && activity.get('action') != 'delete') this.$router.push(notification.get('url'));
      //   this.$refs.notificationPanel.close()
      // },


      // this function is only for new category, this fucntion is no longer in use
      hideNewCategoryModal() {
        this.newCategory = ''
        this.newCategoryPashto = ''
        this.newCategoryDari = ''
      },

      goto(to) {
        this.$refs.notificationPanel.close()
        let url = to || "/";
        this.$router.push(url);
      },

      async logout() {
        await store.dispatch("logout");
        this.showChat = false
        this.$router.push({
          name: 'login'
        });
      },

      toggleChat() {
        if (this.chatLoggedIn) {
          this.showChat = !this.showChat;
        } else {
          this.loginToChat(true);
        }
      },

      chatLoaded() {
        // setTimeout(() => {
        // }, 1000);
      },

      loginToChat(toggle) {
        if (this.user != null && !this.user.get('roles').includes('guest')) {
          axios.post(
            'https://nepachat.speensoft.net/api/v1/login', {
            user: this.user.get('username'),
            password: "passnepa"
          })
            .then(response => {
              if (response.data.status == 'success') {
                var _func = (e) => {
                  switch (e.data.eventName) {
                    case "startup":
                      document.getElementsByName("chatFrame")[0].contentWindow.postMessage({
                        externalCommand: 'login-with-token',
                        token: response.data.data.authToken
                      }, '*')
                      this.chatLoggedIn = true;
                      this.showChatButton = true;
                      window.removeEventListener('message', _func);
                      break;
                    default:
                      break;
                  }
                }
                window.addEventListener('message', _func);
                if (toggle)
                  this.showChat = !this.showChat;
              }
            })
            .catch(e => {
              // this.errors.push(e)
              ;
            });
        }
      },



      resizer() {
        if (this.$refs && this.$refs.topBar && this.$refs.topBar.$el) {
          let topBarHeight = this.$refs.topBar.$el.clientHeight;
          this.$nextTick(() => this.$refs.pageContainer.$el.style.top = topBarHeight + 'px')
        }
      },

    },

    async mounted() {
      window.addEventListener("resize", this.resizer);
      this.resizer()

      if (this.user != null && this.user.get('is_active') == true) {
        if (this.user) this.changeSystemLanguageTo(this.user.get('language'));
        if (this.user && !this.$route.meta.isPublicView) {
          this.myUser = await this.g_fetchObject(this.user.id, 'User')

          if (this.user) {
            await this.fetchUnseenNotificationsCount()
            await this.fetchNotificationsCount()
            await this.fetchNotifications(1)
          }

          // this is for reload

          if (this.user) {
            this.loginToChat();
          }
        }
      } else if (this.user != null && this.user.get('is_active') == false) {
        this.logout(null);
      }
      this.$store.commit('setLoading', false)
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.resizer)
    }
  };
</script>

<style>
  .deadCenter {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }

  .fixed_td table td {
    max-width: 100px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .actions_btn:hover {
    color: black !important
  }

  .dimmed {
    opacity: 0.05;
  }

  .dimmed_no_click {
    pointer-events: none
  }

  .back_button {
    margin-right: 20px !important;
  }

  .field_label {
    text-transform: uppercase;
    font-size: 0.8em;
    display: block;
    color: #848890;
    padding: 6px 1px;
  }

  .file_text {
    font-size: 0.8em;
    height: 17px;
    margin-top: 4px;
    max-width: 150px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 !important
  }

  .file_text:hover {
    color: black !important
  }

  .file_chip {
    margin: 5px 0;
    border: 1px solid gray;
    border-radius: 3px;
    height: 28px;
    max-width: 150px;
    display: flex;
    padding: 0px 4px;
  }

  .section {
    position: absolute;
    margin-top: -15px;
    font-size: 9px;
    font-weight: lighter;
    text-transform: uppercase;
    color: #a7a7a7;
    margin-bottom: 20px
  }

  .notifs ul {
    max-height: 500px !important;
  }

  .description_container img {
    max-width: 100% !important;
  }

  .brand_icon {
    display: flex;
    top: 22%;
    position: absolute;
    margin-top: -18px;
    left: 2%;
  }

  .large_screen_chat {
    position: fixed;
    z-index: 10000;
    width: 340px;
    height: calc(100vh - 90px);
    right: 0;
    top: 100px;
    border: 0px;
    border-left: 2px solid #dbdcdf44
  }

  .small_screen_chat {
    position: fixed;
    z-index: 10000;
    width: 340px;
    height: calc(100vh - 210px);
    right: 0;
    top: 100px;
    border: 0px;
    border-left: 2px solid #dbdcdf44
  }

  .brand_icon_desktop {
    /* display: flex;
    top: 22%;
    position: absolute;
    margin-top: -18px; */
  }
</style>